import {
    militaryToBackgroundTimeSlot,
    resolveBackgroundTimeSlot,
    resolveHistoricalSceneFromMessages
} from '../../shared/message-tree.js';
import { parseClockHour, resolveScenarioBackdrop } from '../../shared/session-backdrop.js';

const SELECT_VALUE_BY_SLOT = { day: '0.1', sunset: '0.2', night: '0.3' };

const isSelectableLocationId = (locId) => {
    if (locId == null || locId === '') return false;
    const value = String(locId);
    return value !== '0' && value !== '1' && !value.startsWith('ERROR');
};

const locationIdFromBackgroundUrl = (backgroundUrl) => {
    if (!backgroundUrl) return '';
    const match = String(backgroundUrl).match(/(\d+)\.\d+\.webp/) || String(backgroundUrl).match(/(\d+)/);
    return match ? match[1] : '';
};

const toSettingsLocationId = (value) => {
    if (!isSelectableLocationId(value)) return '';
    const parsed = Number.parseInt(String(value).trim(), 10);
    if (!Number.isFinite(parsed) || !isSelectableLocationId(parsed)) return '';
    return String(parsed);
};

const selectValueFromSlot = (slotOrMilitary) => {
    const raw = slotOrMilitary == null ? '' : String(slotOrMilitary).trim();
    if (raw === '0.1' || raw === '0.2' || raw === '0.3') return raw;
    const slot = resolveBackgroundTimeSlot(raw);
    return slot ? (SELECT_VALUE_BY_SLOT[slot] || '') : '';
};

const selectValueFromClockHour = (hour) => {
    const parsed = parseClockHour(hour);
    if (parsed == null) return '';
    return SELECT_VALUE_BY_SLOT[militaryToBackgroundTimeSlot(parsed * 100)] || '';
};

export const mapTimeOfDayToValue = (timeOfDay) => selectValueFromSlot(timeOfDay) || '0.1';

export const resolveSettingsBackdrop = ({
    historicalScene = null,
    config = null,
    scenario = null,
    clockHour = null,
    backgroundUrl = null
} = {}) => {
    const scenarioBackdrop = resolveScenarioBackdrop(scenario);
    const backgroundId = toSettingsLocationId(historicalScene?.locationId)
        || toSettingsLocationId(config?.loc_id)
        || toSettingsLocationId(scenarioBackdrop?.locId)
        || toSettingsLocationId(locationIdFromBackgroundUrl(backgroundUrl || config?.backgroundUrl));

    const timeValue = selectValueFromClockHour(clockHour)
        || selectValueFromClockHour(config?.timeHour)
        || selectValueFromSlot(historicalScene?.time)
        || selectValueFromSlot(historicalScene?.timeOfDay)
        || selectValueFromSlot(scenarioBackdrop?.timeOfDay)
        || '0.1';

    return { backgroundId, timeValue };
};

export const readHistoricalSettingsScene = (messages, tipPath) => {
    if (!tipPath) return null;
    return resolveHistoricalSceneFromMessages(messages, tipPath);
};
